import { useMemo } from 'react';
import { Flex, cssVar, Text } from '@cad-arc';
import { TransportForm, HospitalTransportFormView } from '@mark43/cad-api';
import { HospitalStatusTag } from '../../../common/components/hospital-status-tag';
import { useIntegratedForm } from '../../../forms/use-integrated-form';

export function HospitalTransportLocationSelectOption({
    hospitals,
    hospitalId,
}: {
    hospitals: HospitalTransportFormView[];
    hospitalId: number;
}) {
    const { form } = useIntegratedForm<TransportForm>();

    const hospital = useMemo(() => hospitals?.find((hospital) => hospital.id === hospitalId), [
        hospitals,
        hospitalId,
    ]);

    const setSelectedHospital = () => {
        form.setValue('hospitalId', hospitalId);
    };

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            onClick={setSelectedHospital}
            width="100%"
            padding="5px 10px"
            borderRadius="6px"
            _hover={{
                backgroundColor: cssVar('arc.colors.interactive.hover'),
            }}
            style={{
                cursor: 'pointer',
            }}
        >
            <Text as="span">{hospital?.name ?? ''}</Text>
            {hospital?.hospitalStatus && (
                <HospitalStatusTag
                    hospitalStatus={hospital?.hospitalStatus}
                    hospitalStatusGlobalAttributeId={hospital?.hospitalStatusGlobalAttributeId}
                />
            )}
        </Flex>
    );
}
